import { routeAccessConfig } from '@npm-client-frontends/client-frontends-shared-types'
import { match } from 'path-to-regexp'
import { useUserCognitoGroups } from './useUserCognitoGroups'

export const useAccessControl = () => {
  const { userAudienceGroups } = useUserCognitoGroups()

  const checkAccess = (currentPath: string): boolean => {
    return routeAccessConfig.every((routeConfig) => {
      const matcher = match(routeConfig.path, { decode: decodeURIComponent })
      const matched = matcher(currentPath)
      if (matched) {
        if (
          routeConfig.rejectedGroups.some((group) =>
            userAudienceGroups.includes(group),
          )
        ) {
          return false
        }
        return (
          routeConfig.requiredGroups.length === 0 ||
          routeConfig.requiredGroups.some((group) =>
            userAudienceGroups.includes(group),
          )
        )
      }
      return true
    })
  }

  return { checkAccess }
}
